import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { wrapStructure } from 'util/structure-module';

const moduleFn = () => import('structure/settings').then((m) => ({ structureModule: wrapStructure(m.SettingsStructure) }));

export default function SettingsLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/settings/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'settings',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
